import { render, staticRenderFns } from "./InputScore.vue?vue&type=template&id=6b8bb06a&"
import script from "./InputScore.vue?vue&type=script&lang=ts&"
export * from "./InputScore.vue?vue&type=script&lang=ts&"
import style0 from "./InputScore.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports